import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '姓名'
  }, {
    componentType: 'el-input',
    componentName: '下拉选择',
    fieldKey: 'username',
    fieldName: '用户名'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'action',
    fieldName: '操作'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'comment',
    fieldName: '备注'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '创建时间'
  }
]
